import type { OnDestroy, OnInit } from '@angular/core';
import { Directive, output } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[ngTemplateLifecycle]',
})
export class NgTemplateLifecycleDirective implements OnInit, OnDestroy {
  public ngInit = output<void>();
  public ngDestroy = output<void>();

  public ngOnInit() {
    this.ngInit.emit();
  }

  public ngOnDestroy() {
    this.ngDestroy.emit();
  }
}
